// Copyright (c) StrangeBee 2024

import React, { ReactElement, useState } from 'react';
import { FillType, SecurityTagType } from '@Types';
import { ColorLabel } from '@Atoms/Info/ColorLabel/ColorLabel';
import { SecurityTags } from '@Constants/security';
import { classList } from '@Helpers/className';

import './SecurityTag.scss';

interface SecurityTagProps {
    minimal?: boolean;
    type?: SecurityTagType;
    value?: number;
    fillType?: FillType;
    hasLabel?: boolean;
    hasFullSeverityLabel?: boolean;
    uncolored?: boolean;
    className?: string;
    content?: string;
    onClick?: () => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
}

const SecurityTag = ({
    minimal = false,
    type = 'tlp',
    value,
    className = '',
    fillType = 'outline',
    uncolored = false,
    hasLabel = true,
    hasFullSeverityLabel = false,
    content,
    onClick,
}: SecurityTagProps): ReactElement | null => {
    const [hover, setHover] = useState(false);

    const tag = SecurityTags(hasLabel, hasFullSeverityLabel)[type].find(({ value: tagValue }) => tagValue === value);

    if (!tag) {
        return null;
    }

    const labelProcessed = minimal ? tag.label[0] : tag.label;

    return (
        <ColorLabel
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            label={content || labelProcessed}
            color={uncolored && !hover ? 'lightgray' : tag.color}
            className={classList('security-tag', className)}
            type={fillType}
            onClick={onClick}
        />
    );
};

export default SecurityTag;
